<template>
  <svg
    width="12.41"
    height="17.24"
    viewBox="0 0 18 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 .004H2c-.733 0-1.333.6-1.333 1.333v21.334c0 .733.6 1.333 1.333 1.333h4c.733 0 1.333-.6 1.333-1.333V1.337C7.333.604 6.733.004 6 .004zm10.667 0h-4c-.734 0-1.334.6-1.334 1.333v21.334c0 .733.6 1.333 1.334 1.333h4c.733 0 1.333-.6 1.333-1.333V1.337c0-.733-.6-1.333-1.333-1.333z"
      fill="#FFF"
    />
  </svg>
</template>

<script>
export default {
  name: 'AudioPauseIcon'
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/icons/AudioPauseIcon.vue